/**
 * `P0-UIK-001`: the tone vocabulary of 4.6.3, and the classes each tone wears.
 *
 * **Why this union is declared here as well as in `@hakili/domain-types`.**
 * 9.3.1 forbids `packages/ui` from importing `domain-types` , *"a UI component
 * cannot learn what a dossier is"* , while 9.2 sends a chip colour to
 * `domain-types`. Both are right, and they are answering different questions:
 * `domain-types` says WHICH tone a domain state carries, this file says what a
 * tone LOOKS like. The app reads the first and passes it to the second, which
 * is why `Chip` takes a tone as a prop and never derives one.
 *
 * The two unions are held equal by `scripts/tone-vocabulary.spec.ts`, which
 * lives in repository machinery precisely because it is the one place allowed
 * to read both sides. Two copies with a test between them, again.
 */
export const TONES = ["ok", "attention", "alerte", "neutre"] as const;
export type Tone = (typeof TONES)[number];

/**
 * 4.6.3's own pairs. Only tokens from the frozen preset appear here, which
 * `hakili/no-app-colour` enforces , a tone is a decision about meaning, and
 * inventing a shade to express one is how a design system stops being one.
 */
export const TONE_CLASSES: Readonly<Record<Tone, string>> = {
  ok: "bg-emerald-50 text-emerald-700",
  attention: "bg-amber-50 text-amber-700",
  alerte: "bg-rose-50 text-rose-700",
  neutre: "bg-gray-50 text-gray-500",
};
